<template>
    <div>
        <v-toolbar class="glass rounded-lg" flat>
            <v-toolbar-title>
                <span >Our Products</span>
            </v-toolbar-title>
            <v-spacer/>
            <inertia-link as="v-btn" :href="route('admin.courses.create')" color="primary" depressed >
                Add New Course
            </inertia-link>
        </v-toolbar>
        <div class="glass pa-3">
            <v-card outlined  >
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="$page.props.courses"
                    >
                        <template v-slot:item.preview_image="{ item }">
                            <img
                                :src="item.preview_image"
                                height="90px"
                                class="ma-1 rounded-lg"
                                alt=""
                            />
                        </template>

                        <template v-slot:item.is_published="{ item }">
                            <v-switch
                                inset
                                v-model="item.is_published"
                                :true-value="1"
                                :false-value="0"
                                disabled
                            />
                        </template>

                        <template v-slot:item.is_featured="{ item }">
                            <v-switch
                                inset
                                v-model="item.is_featured"
                                :true-value="1"
                                :false-value="0"
                                disabled
                            />
                        </template>


                        <template v-slot:item.actions="{ item }">
                            <div class="d-flex">
                                <inertia-link
                                    as="v-btn"
                                    class="mx-1"
                                     small
                                     color="success"
                                    :href="route('admin.courses.show',item.id)"
                                >
                                    <v-icon>mdi-pencil</v-icon>
                                </inertia-link>
                                <v-btn class="mx-1" small color="error">
                                    <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>

import AdminLayout from "../AdminLayout";
export default {
    name: "Index",
    layout:AdminLayout,

    data() {
        return {
            headers:[
                        {text:'Course Title', value:'title'},
                        {text:'Image',        value:'preview_image'},
                        {text:'Featured',     value:'is_featured'},
                        {text:'Available',    value:'is_published'},
                        {text:'Actions',      value:'actions',sortable:false},
            ],
        }
    }
}
</script>

<style scoped>

</style>
